module.exports = __webpack_public_path__ + "static/af-privacy-2eb56a2c99b0e1ffedc854667ef9d7b7.pdf";